import { IErrorState } from '../../../types'
import * as constants from '../../constants'

export function errors(state: IErrorState, action: any): IErrorState {
  if (typeof state === 'undefined') {
    return { message: '', updatedAt: Date.now() }
  }
  //Assume all failure actions have an error field
  if (action.type.match(/FAIL/)) {
    return Object.assign({}, state, {
      message: action.payload,
      updatedAt: Date.now()
    })
  }
  return state
}



// WEBPACK FOOTER //
// ./src/state/reducers/errors/index.ts